var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length > 0)?_c('highcharts',{attrs:{"options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }